// import 'moment';
import moment from 'moment';
import React from 'react';
// import MomentUtils from '@date-io/moment';
import DateFnsUtils from '@date-io/date-fns';


import DatePicker from '@mui/lab/DatePicker';

import LocalizationProvider from '@mui/lab/LocalizationProvider';

const MonthPicker = (props) => {
  // The first commit of Material-UI
  const [selectedDate, setSelectedDate] = React.useState(props.value);

  React.useEffect(()=>{
    handleDateChange(moment().format('MM/01/YYYY').valueOf())
    setSelectedDate(moment().format('MM/01/YYYY').valueOf())
  },[])


  const handleDateChange = (date) => {
    // console.log('date', date)
    setSelectedDate(date);
    const month = moment(date).format('MM/01/YYYY')
    const data = {
      startDate: moment(month).startOf('month').toDate().valueOf(),
      endDate: moment(month).endOf('month').toDate().valueOf(),
      month: month,
      monthName: moment(date).format('MMMM')
    }
    props?.handleChange(data)
  };

  

  return (
    <React.Fragment>
    <LocalizationProvider AdapterDateFns={DateFnsUtils}>
        <DatePicker
            autoOk
            // disablePast
            // clearable 
            inputVariant="outlined"
            inputMode="none"
            id="date-picker-dialog"
            format="MM/yyyy"
            value={selectedDate}
            onChange={handleDateChange}
            placeholder="Month Picker"
            className="datepicker"
            views={["month"]}
            openTo="month"
            minDate={new Date('04/01/2021')}
            maxDate={moment().endOf('month')}
            // onClose={handleDateChange}
        />
    </LocalizationProvider>
    <style jsx="true">{`
      .datepicker > div{
        height: 38px;
        color: ${props?.color}
      }
    `}</style>
    </React.Fragment>
  );
}

export default MonthPicker;